'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { writeResumeSession } from '@/lib/resume-session';

export default function CidQuerySync() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const cid = searchParams.get('cid');

    if (!cid) {
      return;
    }

    const trimmedCid = cid.trim();

    if (!trimmedCid) {
      return;
    }

    writeResumeSession({ cid: trimmedCid, href: `/${trimmedCid}` });

    const params = new URLSearchParams(searchParams.toString());
    params.delete('cid');

    const queryString = params.toString();
    const hash = window.location.hash;
    const nextUrl = `${pathname}${queryString ? `?${queryString}` : ''}${hash}`;

    router.replace(nextUrl);
  }, [pathname, router, searchParams]);

  return null;
}
